<script>
    /*
    	SelectedFilterButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiCloseCircleOutline } from '@mdi/js';

    export let node;
    export let onClick;

    onMount(() => {
    })

</script>

<style>
    .selected-filter-button {
        width: fit-content;
        height: fit-content;
        min-width: 130px;
        padding: 5px 15px;
        margin-bottom: 5px;
        font-size: 12px;
        font-weight: 100;
        /* color: white; */
        /* background-color: #DFCDD8; */
        color: var(--tcui-purple);
        background-color: #D3DDF9;        
        border-radius: 10px;
        border: none;
    }

    .selected-filter-button .button-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .selected-filter-button .close-icon {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    :global(.selected-filter-button .close-icon svg) {
        width: 20px;
        height: 20px;
        /* fill: var(--tcui-white); */
        fill: var(--tcui-purple);
        outline: none;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<button class="tcui-button selected-filter-button" on:click={() => onClick(node)}>
    <div class="button-content">
        {node.label}
        <div class="close-icon">
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCloseCircleOutline} /></Icon>
        </div>
    </div>
</button>

